import { useEffect, useRef, useState } from "react";

export function useContextMenu({ isMobile, longPressMs = 600 } = {}) {
  const [menuPos, setMenuPos] = useState(null);
  const longPressTimer = useRef(null);
  const touchMoved = useRef(false);

  // ⭐ NEW: the element that activates the menu
  const targetRef = useRef(null);

  const openMenu = (x, y) => {
    setMenuPos({ x, y });
  };

  const closeMenu = () => {
    setMenuPos(null);
  };

  const startLongPress = (touchEvent) => {
    if (!isMobile) return;

    touchMoved.current = false;
    const touch = touchEvent.touches[0];

    longPressTimer.current = setTimeout(() => {
      if (!touchMoved.current) {
        openMenu(touch.clientX, touch.clientY);
      }
    }, longPressMs);
  };

  const cancelLongPress = () => {
    clearTimeout(longPressTimer.current);
  };

  useEffect(() => {
    const handleContextMenu = (e) => {
      if (isMobile) return; // no desktop right-click on mobile

      // ⭐ Only activate if right-click was inside targetRef
      if (!targetRef.current?.contains(e.target)) return;

      e.preventDefault();
      openMenu(e.clientX, e.clientY);
    };

    const handleTouchStart = (e) => {
      if (!isMobile) return;
      if (!targetRef.current?.contains(e.target)) return;  // ⭐

      startLongPress(e);
    };

    const handleTouchMove = (e) => {
      if (!isMobile) return;
      if (!targetRef.current?.contains(e.target)) return;  // ⭐

      touchMoved.current = true;
      cancelLongPress();
    };

    const handleTouchEnd = (e) => {
      if (!isMobile) return;
      if (!targetRef.current?.contains(e.target)) return;  // ⭐

      cancelLongPress();
    };

    const handleTouchCancel = () => cancelLongPress();

    const handleClick = (e) => {
      // ⭐ Close menu only if click is outside
      if (menuPos && !targetRef.current?.contains(e.target)) {
        closeMenu();
      }
    };

    const handleScroll = () => {
      if (menuPos) closeMenu(); // close menu on scroll
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("touchstart", handleTouchStart, { passive: true });
    document.addEventListener("touchmove", handleTouchMove, { passive: true });
    document.addEventListener("touchend", handleTouchEnd, { passive: true });
    document.addEventListener("touchcancel", handleTouchCancel);
    document.addEventListener("click", handleClick);
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("touchend", handleTouchEnd);
      document.removeEventListener("touchcancel", handleTouchCancel);
      document.removeEventListener("click", handleClick);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [isMobile, menuPos]);

  // ⭐ RETURN targetRef so you can attach it to the element
  return { menuPos, closeMenu, targetRef };
}
